var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5.5c.24546 0 .4496.17688.49194.41012L22 1v1.5h5c1.32548 0 2.41004 1.03154 2.49468 2.33562L29.5 5v18c0 1.32548-1.03154 2.41004-2.33562 2.49468L27 25.5H3c-1.32548 0-2.41004-1.03154-2.49468-2.33562L.5 23V5c0-1.32548 1.03154-2.41004 2.33562-2.49468L3 2.5h5V1c0-.27614.22386-.5.5-.5.24546 0 .4496.17688.49194.41012L9 1v1.5h12V1c0-.27614.22386-.5.5-.5zm.35215 12.29447c-.19603-.1945-.51261-.19324-.7071.0028L12.56 21.451 9.84368 18.88l-.07082-.05593c-.19851-.12958-.4673-.10287-.63602.0754-.1898.20058-.18109.51704.01948.70685l3.071 2.90626.0788.06102c.19411.12147.45249.09664.61983-.07203l8.929-9 .05758-.06948c.13422-.1954.11387-.46475-.06038-.63762zM29 10H1v1h28v-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFilled);
export default __webpack_public_path__ + "static/media/calendar-filled.31bbc50c.svg";
export { ForwardRef as ReactComponent };